<template>
  <div>
    <h1 class="text-center">Hunde</h1>

    <div class="text-center mt-4">
      <p>
        Kennel Hillsbrook har i øjeblikket 4 hunde. Alle hundene har grundtræningen i orden, og sundheden i top.
        <br />De er nemmere at dressere og er bløde i sind.
      </p>
    </div>

    <!-- Todo: Mindre height? -->
    <v-img :src="`${publicPath}images/Paddy og Bastian.jpg`"></v-img>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Hunde',
  data: () => ({
    publicPath: process.env.BASE_URL
  }),
  computed: {
    ...mapState(['test', 'dogs'])
  }
};
</script>
